export default __webpack_public_path__ + "static/media/together-for-gold-fr.dbd5771c.png";